export function convertMLToLiter(value: number) {
  return Math.round(value * 1000000);
}

export function convertLiterToML(value: number) {
  return (value / 1000000).toFixed(3);
}
